import { Box } from "@chakra-ui/react";
import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectAppState } from "../../app/slice/appSlice";
import { selectConditionsState } from "../../app/slice/conditionSlice";
import { navigateTo } from "../../app/slice/mobileSlice";
import Conditions from "../CheckoutPage/components/Conditions";
import MobileHeader from "./MobileHeader";

const MobileConditionsScreen = () => {
  const dispatch = useAppDispatch();
  const { activePage } = useAppSelector(selectAppState);
  const { selectedConditionId } = useAppSelector(selectConditionsState);
  const initialConditionId = useRef<string | undefined>(undefined);
  const hasInitialized = useRef(false);

  useEffect(() => {
    hasInitialized.current = false;
    initialConditionId.current = undefined;
  }, [activePage]);

  useEffect(() => {
    if (!selectedConditionId) return;

    if (!hasInitialized.current) {
      initialConditionId.current = selectedConditionId;
      hasInitialized.current = true;
      return;
    }

    if (initialConditionId.current !== selectedConditionId) {
      initialConditionId.current = selectedConditionId;
      dispatch(navigateTo("slots"));
    }
  }, [selectedConditionId, dispatch]);

  return (
    <Box h="100%" w="100%" bg="neutrals.200" display="flex" flexDirection="column" overflow="hidden">
      <MobileHeader screen="conditions" />
      <Box flex={1} minH={0} px="12px">
        <Conditions />
      </Box>
    </Box>
  );
};

export default MobileConditionsScreen;
